export const style = `
.Select-input input{
  border:0px solid!important;
}
.Select-menu-outer{
  z-index:7;
}

/* Disabled state styling */
&.is-disabled {
  .Select-control {
    background-color: #f5f5f5 !important;
    cursor: not-allowed;
  }
  .Select-value-label {
    color: rgba(0, 0, 0, 0.6) !important;
  }
  .Select-placeholder {
    color: rgba(0, 0, 0, 0.4) !important;
  }
}
`;

export default style;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/Select/style.js